import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import OnboadingHeader from './onboadingHeader'
import Interests from './interests';
import OnboadingComplete from './onboadingComplete';
import { decryptData } from '../../../../utils/api/encrypted';
import { useSelector } from 'react-redux';
import OnboadingReview from './onboadingReview';

const ONBOARDING_KEY = 'onboarding_completed';
const LEGACY_ONBOARDING_KEY = 'onboading_completed';

/** Prefer new key; if only legacy is set, migrate once and prefer new. */
const readOnboardingCompleted = () => {
  const neu = localStorage.getItem(ONBOARDING_KEY);
  if (neu === 'true' || neu === true || neu === '1') {
    return true;
  }
  const legacy = localStorage.getItem(LEGACY_ONBOARDING_KEY);
  if (legacy === 'true' || legacy === true || legacy === '1') {
    localStorage.setItem(ONBOARDING_KEY, 'true');
    localStorage.removeItem(LEGACY_ONBOARDING_KEY);
    return true;
  }
  return false;
};

const Onboading = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const encryptedData = useSelector(state => state.appData?.userData);
  const userData = decryptData(encryptedData);
  useEffect(() => {
    checkOnboardingStatus();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  const checkOnboardingStatus = () => {
    try {
      const apiResponse = userData;
      const prevCompleted = readOnboardingCompleted();
      if (!apiResponse?.created || prevCompleted) {
        navigate('/home', { replace: true });
        return;
      }

      setIsLoading(false);

    } catch (error) {
      console.error('Error checking onboarding status:', error);
      navigate('/home', { replace: true });
    }
  };

  const nextStep = () => {
    if (currentStep < 3) {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[var(--primary)] mx-auto"></div>
          <p className="mt-2 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className=''>
        {currentStep !== 3 && <OnboadingHeader step={currentStep} setPrev={prevStep}/>}
        {currentStep === 1 && <OnboadingReview setStep={nextStep}/>}
        {currentStep === 2 && <Interests setStep={nextStep}/>}
        {currentStep === 3 && <OnboadingComplete />}
      </div>
    </>
  )
}

export default Onboading
